import { SvgIcon } from "@mui/material";
import { useTranslations } from "next-intl";
import Link from "next/link";
import React, { ReactNode } from "react";

import styled from "@emotion/styled";
import useUserSettingsMenuItems, {
  MenuItem,
} from "custom-hooks/use-user-settings-menu-items.hook";
import Image from "next/image";
import { useAppSelector } from "custom-hooks/redux.hooks";

function UserSettingsLayout({ children }: any) {
  const t = useTranslations("SettingsLayout");
  const menu = useUserSettingsMenuItems();
  const _user = useAppSelector((state) => state.Auth.user);


  return (
    <Container>
      {
        _user && (
        <aside className="sidebar">
          <h3>{t("title")}</h3>
          <RecursiveItems items={menu} />
        </aside>
        )
      }

      <div className="main">{children}</div>
    </Container>
  );
}

function RecursiveItems({
  items,
  padding = 0,
}: {
  items: MenuItem[];
  padding?: number;
}) {
  return (
    <>
      {items.map((item) => (
        <div
          style={{ paddingLeft: padding }}
          className={padding == 0 ? "root" : "node"}
          key={item.slug}
        >
          {item.link ? (
            <>
              <Link href={item.link}>
                <a className="link-tag">
                  <ItemLabel item={item} />
                </a>
              </Link>
              {item.children && (
                <RecursiveItems items={item.children} padding={padding + 30} />
              )}
            </>
          ) : (
            <ItemLabel item={item}>
              {item.children && (
                <RecursiveItems items={item.children} padding={padding + 30} />
              )}
            </ItemLabel>
          )}
        </div>
      ))}
    </>
  );
}

function ItemLabel({
  item: { icon, slug, style },
  children,
}: {
  item: MenuItem;
  children?: ReactNode;
}) {
  return (
    <>
      <span className={[style ?? "thin", "label"].join(" ")}>
        {typeof icon === "string" ? (
          <Image
            // style={{paddingRight: "9"}}
            src={icon}
            alt={slug + " icon"}
            width={17}
            height={17}
          />
        ) : (
          icon && <SvgIcon component={icon} inheritViewBox />
        )}
        &nbsp;{slug}
      </span>
      {children}
    </>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 250px 1fr;
  min-height: var(--main-height);

  .root {
    margin: 20px 0 10px;
  }

  .node {
    margin-top: 10px;
  }

  .link-tag {
    &:hover {
      text-decoration: underline;
    }
  }

  .label {
    display: flex;
    align-items: center;

    .bold {
      font-weight: 700;
      color: var(--color-main-blue);
    }
  }

  .sidebar {
    padding: 20px;
    background: #fafafa;
    overflow-y: auto;

    a {
      display: block;
      font-size: 16px;
      margin-bottom: 5px;
    }
  }

  @media (max-width: 899px) {
    grid-template-columns: 100%;

    aside.sidebar {
      display: none;
    }
  }
`;

export default UserSettingsLayout;
